export default "__VITE_ASSET__C3x822zS__"